module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAQlBMVEUAAADbS0vbS0vbS0vbTEzbS0vbTEzbS0veUVHbS0vbS0veUFDbS0viV1fjWVnlXFznX1/gU1PreHjth4f///8AAACvtrqnAAAADHRSTlMAAlGp7TPX/v1O+v3jGtxUAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+EHDQ8NH2J8Us8AAABsSURBVBjTbZBJDsAgDAPDvpMA/f9bi2iFaJU5Wk5kG2AipNI5ayUFvBjrfKm1eGfNo4SYkBaYYlie2GjT4vQJm+ggWQHS4Smhk6A8ffAKdKE+Np2KhlzHdTBq5iTmkHnPhGCiMoW42tw4/wlv5s0O0fIfx7kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/iexplore/components/alert/static/prompt.png
// module id = 1050
// module chunks = 2